import autobind from 'autobind-decorator';
import { showErrorMsg, showSuccessMsg } from '#imports';
import { Inject, Injectable, forwardRef } from '@kaokei/use-vue-service';
import { getCodeSummary } from '~/api/im';

@Injectable()
export class CodeActionService {
  public visible = false;

  @autobind
  public getCodeSummary({ pid, code }: { pid: number; code: string }) {
    return getCodeSummary({ pid, code }).then((res) => {
      return res;
    });
  }
}
